<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-28 09:50:37
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-02-03 11:13:05
-->
<template>
  <div>
    <el-button size="small" style="margin-right: 6px; padding: 8px 10px" @click="handleRefreshTable">
      <em class="el-icon-refresh-right text-16px" />
      刷新表格
    </el-button>
    <el-popover placement="bottom" trigger="click" v-if="columnsSetting">
      <template #reference>
        <el-button size="small" style="padding: 8px 10px">
          <em class="iconfont icon-shezhi text-16px" />
          表格列设置
        </el-button>
        <!-- <el-button icon="el-icon-s-operation"
                 circle
                 class="text-16px"></el-button> -->
      </template>
      <div class="w-180px">
        <vue-draggable v-model="list" @end="handleCheckboxChange">
          <div
            v-for="(element, elementIndex) in list"
            :key="elementIndex"
            class="flex-y-center h-36px px-12px hover:bg-primary_active"
          >
            <em class="el-icon-s-grid cursor-move mr-8px"></em>
            <el-checkbox v-model="element.checked" @change="handleCheckboxChange">
              {{ element.label }}
            </el-checkbox>
          </div>
        </vue-draggable>
      </div>
    </el-popover>
  </div>
</template>
<script>
  import VueDraggable from 'vuedraggable'

  export default {
    name: 'XColumnConfig',
    components: { VueDraggable },
    props: {
      columns: {
        type: Array,
        default: () => []
      },
      columnsSetting: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        list: []
      }
    },
    watch: {
      columns: {
        handler() {
          this.list = this.columns.map((item) => ({ ...item, checked: true }))
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      if (this.result) {
        this.list = this.columns.map((item) => ({ ...item, checked: true }))
      }
    },
    methods: {
      handleCheckboxChange() {
        const newColumns = this.list.filter((item) => item.checked)
        const columns = newColumns.map((item) => {
          const column = { ...item }
          delete column.checked
          return column
        })
        this.$emit('updateColumns', columns)
      },
      handleRefreshTable() {
        this.$emit('on-refresh')
      }
    }
  }
</script>
<style>
  .icon-shezhi.text-16px {
    font-size: 10px;
    margin-right: 4px;
  }

  .w-180px {
    width: 180px;
  }

  .flex-y-center {
    display: flex;
    align-items: center;
  }

  .px-12px {
    padding-right: 12px;
    padding-left: 12px;
  }

  .h-36px {
    height: 36px;
  }

  .cursor-move {
    cursor: move;
  }

  .mr-8px {
    margin-right: 8px;
  }
</style>
